import type { FC } from 'react';

const LoadingSpinner: FC = () => (
  <div className="schedule-meeting-modal__body schedule-meeting-modal__body--loading">
    <div className="spinner-container">
      <div className="spinner-dual" />
      <p>Scheduling meeting...</p>
    </div>
  </div>
);

export default LoadingSpinner;
